import { type JSX, splitProps } from 'solid-js'
import { type ButtonSize, type ButtonVariant, buttonClass } from './Button'

export interface ButtonLinkProps extends JSX.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  onTint?: boolean
}

export function ButtonLink(props: ButtonLinkProps) {
  const [local, rest] = splitProps(props, [
    'variant',
    'size',
    'fullWidth',
    'onTint',
    'class',
    'children',
  ])

  return (
    <a
      {...rest}
      class={buttonClass({
        variant: local.variant ?? 'primary',
        size: local.size ?? 'md',
        fullWidth: local.fullWidth,
        onTint: local.onTint,
        class: local.class,
      })}
    >
      {local.children}
    </a>
  )
}
